import documentUpload from "./documentUpload"
export default documentUpload;
